import React from "react";
import CurriculumHeader from "components/header/CurriculumHeader";
import LinkContent from "components/card/LinkContent";

const items = [
  {
    title: "«Աշխարհագրություն»",
    color: "#493ED3",
    content: [
      "Բաժին 1. Ընդհանուր Դրույթներ",
      "Բաժին 2. «Աշխարհագրություն» և «Հայաստանի աշխարհագրություն» ուսումնական առարկաներ ուսուցման նպատակը՝ ըստ կրթական աստիճանների",
    ],
    link: "/concepts-overview/geography",
  },
  {
    title: "«Մայրենի»",
    color: "#9747FF",
    content: [
      "«Մայրենի» առարկան՝ որպես 1-4-րդ և 5-6-րդ դասարաններում ուսուցանվող դասընթացներ, բացառիկ տեղ է «Ազգային Դպրոցի» տարրական և միջին օղակում։ Նրա քաղաքակրթական բովանդակության ապահովման համար ակնկալում ենք հենց Քո աջակցությունը։",
    ],
  },
  {
    title: "«Իմ Հայրենիքը»",
    color: "#9747FF",
    content: [
      "Առարկայի քաղաքակրթական բովանդակությամբ հայեցակարգի, չափորոշիչների, ծրագրերի և էլեկտրոնային դասագրքերի ստեղծման համար ակնկալվում է ազգային ապագա սերնուդների դաստիարակությանը ոչ անտարբեր բոլոր մասնագետների համագործակցությունը։",
    ],
  },
  {
    title: "«Իմ հայրենիքը» և «Իմ հայրենիքն ու աշխարհը»",
    color: "#493ED3",
    content: [
      "Առարկաները «Ազգային Դպրոցում» կարևոր տեղ են զբաղեցնում Հայաստանն ու հայ ժողովրդը, համաշխարհային պատմությունը, մշակույթը, կրոնը, աշխարհագրությունը, քաղաքակրթական բովանդակությամբ ուսումնասիրելու գործընթացում։ Համագործակցի՛ր։",
    ],
  },
  {
    title: "«Հայոց լեզու» և « Հայ գրականություն»",
    content: [
      "Առարկաները պետք է ապահովեն ազգային-քաղաքակրթական ինքության համար անփոխարինելի համարվող ազգային լեզվամտածողությունը։ Պատրաստ ե՛ս համագործակցության, միասին կարող ենք ստեղծարարել․․․",
    ],
    color: "#493ED3",
  },
  {
    title: "«Հայոց պատմություն»",
    content: [
      "Առարկան՝ որպես ազգային-քաղաքակրթական ինքնությունն ապահովող հիմնական առարկա, պետք է իր բովանդակությամբ համապատասխանի ազգային ապագա առաքելության իրացմանը։ Ստեղծարար համագործակցությամբ կարող ենք միասին արարել մեր քաղաքակրթական կենսընթացի ողջ պատմությունը։",
    ],
    color: "#9747FF",
  },
  {
    title: "«Համաշխարհային պատմություն» և «Հասարակագիտություն»",
    content: [
      "Համաշխարհային պատմություն և հասարակական կյանքի ոլորտներ ուսումնասիրող առարկաները ապահովելու են համաշխարհային քաղաքակրթական ճառանգության հետ հաղորդակցումը։ Միացիր, որպեսզի այդ ամենը կառուցվի բացարձակապես արժեքային հիմքի վրա։։",
    ],
    color: "#9747FF",
  },
];

const ConceptsOverview = () => {
  return (
    <div className="flex flex-col justify-center gap-24 xl:gap-10 mx-6 xl:mx-24 mt-10">
      <CurriculumHeader
        title="ՀԱՅԵՑԱԿԱՐԳԵՐ"
        sectionTitle="ՑԱՆԿ"
        buttonTitle="Առարկայացանկ"
        buttonLink="/subjects-list"
      />
      <div class="xl:p-[48px_100px] justify-between items-center bg-white rounded-[24px]">
        <h3 class="text-[#493ED3] font-noto-sans-armenian text-[24px] font-semibold leading-normal mb-4">
          Առարկաների ցանկում համապատասխան hայեցակարգերի հղումներ են։
        </h3>

        <div className="flex flex-col">
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-[24px] mb-6">
            {items.map((item, index) => (
              <LinkContent
                key={index}
                title={item.title}
                content={item.content}
                link={item.link}
                color={item.color}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConceptsOverview;
